import React, { useEffect, useState } from "react";
const MODERN_ALERT_EVENT = "modern-alert-event";

const ModernAlertHost = () => {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    const originalAlert = window.alert;

    const handleAlertEvent = (event) => {
      const message = String(event?.detail?.message ?? "");
      if (!message) return;

      const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      setAlerts((prev) => [...prev, { id, message }]);

      window.setTimeout(() => {
        setAlerts((prev) => prev.filter((item) => item.id !== id));
      }, 3500);
    };

    window.alert = (message) => {
      window.dispatchEvent(
        new CustomEvent(MODERN_ALERT_EVENT, {
          detail: { message: String(message ?? "") },
        })
      );
    };

    window.addEventListener(MODERN_ALERT_EVENT, handleAlertEvent);

    return () => {
      window.removeEventListener(MODERN_ALERT_EVENT, handleAlertEvent);
      window.alert = originalAlert;
    };
  }, []);

  if (alerts.length === 0) return null;

  return (
    <div className="fixed top-5 right-5 z-[99999] flex w-[360px] max-w-[calc(100vw-2rem)] flex-col gap-3">
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className="relative overflow-hidden rounded-2xl border border-white/50 bg-gradient-to-b from-[#A1E0F4]/95 to-[#F0B1AF]/95 p-4 text-[#16343a] shadow-[0_14px_36px_rgba(0,0,0,0.22)] backdrop-blur-xl"
        >
          <button
            type="button"
            onClick={() => setAlerts((prev) => prev.filter((item) => item.id !== alert.id))}
            className="absolute right-2 top-2 h-7 w-7 rounded-full border border-white/60 bg-white/40 text-sm font-bold text-[#16343a] transition hover:bg-white/60"
            aria-label="Close alert"
          >
            x
          </button>
          <p className="pr-8 text-sm font-semibold whitespace-pre-line">{alert.message}</p>
        </div>
      ))}
    </div>
  );
};

export default ModernAlertHost;
